// import React, { useEffect, useState } from "react";
// import { Box, LinearProgress, Typography } from "@mui/material";

// interface Props {
//   /** Time limit in minutes (default: 10) */
//   timeLimit?: number;
//   onExpire: () => void;
//   running?: boolean;
// }

// const Timer: React.FC<Props> = ({
//   timeLimit = 10, // Default: 10 minutes
//   onExpire,
//   running = true,
// }) => {
//   const totalSeconds = timeLimit * 60;
//   const [timeLeft, setTimeLeft] = useState<number>(totalSeconds);

//   // Reset timer if timeLimit changes
//   useEffect(() => {
//     setTimeLeft(totalSeconds);
//   }, [timeLimit]);

//   // Countdown logic
//   useEffect(() => {
//     if (!running) return;
//     const timer = setInterval(() => {
//       setTimeLeft((prev) => {
//         if (prev <= 1) {
//           clearInterval(timer);
//           onExpire();
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [onExpire, running]);

//   // Formatting
//   const minutes = Math.floor(timeLeft / 60);
//   const seconds = timeLeft % 60;

//   // ✅ Correct percentage calculation
//   const percent = Math.max(0, (timeLeft / totalSeconds) * 100);

//   return (
//     <Box sx={{ width: "100%", mb: 2 }}>
//       <Typography
//         variant="body2"
//         align="center"
//         sx={{ mb: 1, fontWeight: 600 }}
//       >
//         Time left: {minutes}:{seconds.toString().padStart(2, "0")}
//       </Typography>
//       <LinearProgress
//         variant="determinate"
//         value={percent}
//         sx={{ height: 10, borderRadius: 5 }}
//       />
//     </Box>
//   );
// };

// export default Timer;
import React, { useEffect, useState } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

interface Props {
  /** Time limit in minutes (default: 10) */
  timeLimit?: number;
  onExpire: () => void;
  running?: boolean;
  /** optional callback to report elapsed seconds to parent */
  onTick?: (elapsedSeconds: number) => void;
}

const Timer: React.FC<Props> = ({
  timeLimit = 10, // Default: 10 minutes
  onExpire,
  running = true,
  onTick,
}) => {
  const totalSeconds = timeLimit * 60;
  const [timeLeft, setTimeLeft] = useState<number>(totalSeconds);

  // Reset timer if timeLimit changes
  useEffect(() => {
    setTimeLeft(totalSeconds);
    onTick?.(0);
  }, [timeLimit]);

  // Countdown logic
  useEffect(() => {
    if (!running) return;
    onTick?.(totalSeconds - timeLeft); // report current elapsed on start/resume

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onTick?.(totalSeconds); // full elapsed
          onExpire();
          return 0;
        }
        const next = prev - 1;
        onTick?.(totalSeconds - next);
        return next;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [onExpire, running, onTick, totalSeconds]);

  // Formatting
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  // ✅ Correct percentage calculation
  const percent = Math.max(0, (timeLeft / totalSeconds) * 100);

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Typography
        variant="body2"
        align="center"
        sx={{ mb: 1, fontWeight: 600 }}
      >
        Time left: {minutes}:{seconds.toString().padStart(2, "0")}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{ height: 10, borderRadius: 5 }}
      />
    </Box>
  );
};

export default Timer;
